import { lazy } from "react";

const PrivacyPage = lazy(() => import("../about/PrivacyPage"));
const FaqPage = lazy(() => import("../about/FaqPage"));
const InstructionsPage = lazy(() => import("../about/InstructionsPage"));
const DigitalSigningPage = lazy(() => import("../about/DigitalSigningPage"));
const StaticContractsPage = lazy(() => import("../about/StaticContractsPage"));
const AboutPage = lazy(() => import("../about/AboutPage"));
const TermsPage = lazy(() => import("../about/TermsPage"));
const MonthlyPaymentPage = lazy(
  () => import("../about/MonthlyPaymentTermsPage")
);
const BecomeMemberPage = lazy(() => import("../membership/BecomeMemberPage"));
const MembershipPaymentPage = lazy(
  () => import("../membership/MembershipPaymentPage")
);
const RecurringMembershipPaymentPage = lazy(
  () => import("../membership/RecurringMembershipPaymentPage")
);

const StaticRoutes = {
  digitalSigning: {
    path: "/om/digital-signering",
    component: DigitalSigningPage,
  },
  faq: {
    path: "/om/sporsmal-og-svar",
    component: FaqPage,
  },
  instructions: {
    path: "/om/utfylling-av-kontrakt",
    component: InstructionsPage,
  },
  privacy: {
    path: "/om/cookies-og-personvern",
    component: PrivacyPage,
  },
  staticContracts: {
    path: "/om/last-ned-kontrakt",
    component: StaticContractsPage,
  },
  terms: {
    path: "/om/vilkar",
    component: TermsPage,
  },
  monthlyPayment: {
    path: "/om/vilkar-manedlig-betaling",
    component: MonthlyPaymentPage,
  },
  about: {
    path: "/om",
    component: AboutPage,
  },
  membershipPayment: {
    path: "/bli-medlem/betaling/:paymentId/:signature",
    component: MembershipPaymentPage,
  },
  membershipRecurringPayment: {
    path: "/bli-medlem/manedlig-betaling/:recurringPaymentId/:signature",
    component: RecurringMembershipPaymentPage,
  },
  becomeMember: {
    path: "/bli-medlem",
    component: BecomeMemberPage,
  },
};

export default StaticRoutes;
